export default "__VITE_ASSET__DLtp3rvE__"